// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"c2762f52","320":"47f64d41"}[chunkId] + ".chunk.css";
};